import { Link } from 'react-router-dom';
import css from './MailToAll.module.css';

function MailToAll({ courseDetails }) {
    return (
        <div>
            <button className={css.button}>
                <Link
                    to={`mailto:a.georgiev@pc-acad.com?cc=ts.yankova@pc-acad.com,zh.zhelev@pc-acad.com&bcc=${courseDetails.map(
                        (x) => x.studentEmail
                    )}&subject=(${courseDetails[0].courseNo}) ${courseDetails[0].courseTitle}`}
                >
                    Mail to all
                </Link>
            </button>
        </div>
    );
}

export default MailToAll;
